export const RX_BONUS_MODAL = 'rx-bonus-modal'
